import { render, staticRenderFns } from "./StagingBprSectionEditor.vue?vue&type=template&id=3a2990e6"
import script from "./StagingBprSectionEditor.vue?vue&type=script&lang=ts"
export * from "./StagingBprSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./StagingBprSectionEditor.vue?vue&type=style&index=0&id=3a2990e6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports